import React, {FC} from 'react';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {RuleTriggersTypesEnum} from '../ruleTriggerModel';

/*
 * Types.
 */

interface RuleTriggerIconProps {
  trigger: RuleTriggersTypesEnum;
}

/*
 * Component.
 */

export const RuleTriggerIcon: FC<RuleTriggerIconProps> = ({trigger}) => <Icon name={getIconName(trigger)} />;

/*
 * Helpers.
 */

function getIconName(trigger: RuleTriggersTypesEnum): IconName {
  switch (trigger) {
    case RuleTriggersTypesEnum.INBOUND:
      return 'inboxFilled';

    case RuleTriggersTypesEnum.OUTBOUND:
      return 'outbox';

    case RuleTriggersTypesEnum.OUT_REPLY:
      return 'reply';

    case RuleTriggersTypesEnum.MOVE:
      return 'moveRightFilled';

    case RuleTriggersTypesEnum.SENDING_ERROR:
      return 'warningFilledTriangle';

    case RuleTriggersTypesEnum.ARCHIVE:
    case RuleTriggersTypesEnum.REOPEN:
      return 'archiveFilled';

    case RuleTriggersTypesEnum.TRASH:
      return 'trashFilled';

    case RuleTriggersTypesEnum.RESTORE:
      return 'restore';

    case RuleTriggersTypesEnum.SNOOZE:
    case RuleTriggersTypesEnum.SNOOZE_EXPIRED:
      return 'snoozeFilled';

    case RuleTriggersTypesEnum.COMMENT:
      return 'chatFilled';

    case RuleTriggersTypesEnum.MENTION:
      return 'mention';

    case RuleTriggersTypesEnum.ASSIGN:
    case RuleTriggersTypesEnum.UNASSIGN:
      return 'assignFilled';

    case RuleTriggersTypesEnum.TAG:
      return 'tagFilled';

    case RuleTriggersTypesEnum.UNTAG:
      return 'untag';

    case RuleTriggersTypesEnum.TOPIC_ADDED:
      return 'integration';

    case RuleTriggersTypesEnum.TOPIC_REMOVED:
      return 'removeIntegration';

    default:
      return 'inbox';
  }
}
